// extracted by mini-css-extract-plugin
module.exports = {"holder":"styles_holder__zHQC8","title":"styles_title__XH71r","rounded":"styles_rounded__4xGU9"};